import { v4 as uuidv4 } from 'uuid';
const uId = uuidv4();
//import { avatar1 } from './images/avatar/1.jpg'

export const accounts = [
    {
        id: uId,
        name: 'Raghib Hussain',
        userName: 'hussu',
        password: '12345',
        interestRate: 2.5,
        photo: "https://i.pravatar.cc/48?u=499476",
        status: true,
        movements: [
            {
                transactionDate: new Date("November 05, 2024"),
                moves: 12000
            },
            {
                transactionDate: new Date("December 11, 2024"),
                moves: 6000
            },
            {
                transactionDate: new Date("December 17, 2024"),
                moves: -6500
            },
            {
                transactionDate: new Date("December 28, 2024"),
                moves: 100
            },
            {
                transactionDate: new Date("January 05, 2024"),
                moves: 900
            }
        ],
    },
    {
        id: uId,
        name: 'Bindu Kumari',
        userName: 'bindu',
        password: '12345',
        interestRate: 1.5,
        photo: "https://i.pravatar.cc/48?u=118872",
        status: true,
        movements: [
            {
                transactionDate: new Date("November 05, 2024"),
                moves: 3500
            },
            {
                transactionDate: new Date("December 11, 2024"),
                moves: 8000
            },
            {
                transactionDate: new Date("December 22, 2024"),
                moves: -500
            },
            {
                transactionDate: new Date("January 15, 2025"),
                moves: -200
            }
        ],
    },
    {
        id: uId,
        name: 'Jack Ma',
        userName: 'jack',
        password: '12345',
        interestRate: 1.5,
        photo: "https://i.pravatar.cc/48?u=134005",
        status: true,
        movements: [
            {
                transactionDate: new Date("December 05, 2024"),
                moves: -3300
            },
            {
                transactionDate: new Date("December 12, 2024"),
                moves: 12000
            },
            {
                transactionDate: new Date("December 24, 2024"),
                moves: 2200
            },
            {
                transactionDate: new Date("January 16, 2024"),
                moves: -1400
            }
        ],
    },
    {
        id: uId,
        name: 'Rohit Sharma',
        userName: 'rohit',
        password: '12345',
        interestRate: 1.5,
        photo: "https://i.pravatar.cc/48?u=119059578",
        status: true,
        movements: [
            {
                transactionDate: new Date("November 11, 2024"),
                moves: 1200
            },
            {
                transactionDate: new Date("December 05, 2024"),
                moves: 5500
            },
            {
                transactionDate: new Date("December 22, 2024"),
                moves: -2300
            },
            {
                transactionDate: new Date("January 09, 2024"),
                moves: 4500
            }
        ],
    }
]